class MtPicTextGroup {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.root = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!this.root) return;
    
    this.init();
  }

  init() {
    this.loadData();
    this.cacheElements();
    if (!this.slides.length || !this.track || !this.contentTrack) return;
    
    this.blockIndex = 0;
    this.imageIndex = 0;
    this.currentSlideIndex = 0;
    
    this.bindEvents();
    this.relocateDotsForMobile();
    this.showSlide();
  }

  loadData() {
    const dataScript = document.getElementById(`ptg-data-${this.sectionId}`);
    this.blocksData = { items: [] };
    if (dataScript) {
      try {
        this.blocksData = JSON.parse(dataScript.textContent || '{}');
      } catch (e) {
        console.error('Failed to parse blocks data:', e);
      }
    }
  }

  cacheElements() {
    this.slides = Array.from(this.root.querySelectorAll('[data-ptg-slide]'));
    this.slidesMobile = Array.from(this.root.querySelectorAll('[data-ptg-slide-mobile]'));
    this.track = this.root.querySelector('[data-ptg-track]');
    this.contentTrack = this.root.querySelector('[data-ptg-content-track]');
    this.ctaEl = this.root.querySelector('[data-ptg-cta]');
    this.dotsBox = this.root.querySelector('[data-ptg-dots]');
    this.btnPrev = this.root.querySelector('[data-ptg-prev]');
    this.btnNext = this.root.querySelector('[data-ptg-next]');
  }

  bindEvents() {
    if (this.btnPrev) {
      this.btnPrev.addEventListener('click', () => this.prev());
    }
    if (this.btnNext) {
      this.btnNext.addEventListener('click', () => this.next());
    }
    if (this.dotsBox) {
      this.dotsBox.addEventListener('click', (e) => this.handleDotClick(e));
    }
    window.addEventListener('resize', () => this.relocateDotsForMobile());

    // 移动端整体区域左右滑动切换
    this.bindTouchSwipe(this.root);
  }

  bindTouchSwipe(el) {
    if (!el) return;
    let startX = 0;
    let startY = 0;
    let isDragging = false;

    el.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
    }, { passive: true });

    el.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      // 判断是否以水平滑动为主，如果是则阻止页面纵向滚动
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy)) {
        e.preventDefault();
      }
    }, { passive: false });

    el.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const dx = endX - startX;
      const dy = endY - startY;
      // 水平滑动距离超过 40px 且水平方向为主
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    }, { passive: true });
  }

  relocateDotsForMobile() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      const currentMobileMedia = this.root.querySelector(
        `.mt-ptg__content-slide[data-content-block="${this.blockIndex}"] .mt-ptg__media--mobile`
      );
      if (currentMobileMedia && this.dotsBox && this.dotsBox.parentElement !== currentMobileMedia) {
        currentMobileMedia.appendChild(this.dotsBox);
        this.dotsBox.style.position = 'absolute';
      }
    } else {
      const controls = this.root.querySelector('.mt-ptg__controls');
      if (controls && this.dotsBox && this.dotsBox.parentElement !== controls) {
        controls.appendChild(this.dotsBox);
        this.dotsBox.style.position = '';
      }
    }
  }

  updateTrackPosition() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    
    // PC端图片轨道
    const imageOffset = -this.currentSlideIndex * 100;
    const gapOffset = -this.currentSlideIndex * 0;
    if (this.track) {
      this.track.style.transform = `translateX(calc(${imageOffset}% + ${gapOffset}px))`;
    }
    
    // 移动端图片轨道
    if (isMobile) {
      const currentMobileMedia = this.root.querySelector(
        `.mt-ptg__content-slide[data-content-block="${this.blockIndex}"] .mt-ptg__media--mobile`
      );
      if (currentMobileMedia) {
        const currentTrackMobile = currentMobileMedia.querySelector('[data-ptg-track-mobile]');
        if (currentTrackMobile) {
          const currentBlockSlides = Array.from(currentTrackMobile.querySelectorAll('[data-ptg-slide-mobile]'));
          const targetSlideIndex = currentBlockSlides.findIndex(slide => {
            return Number(slide.getAttribute('data-img')) === this.imageIndex;
          });
          if (targetSlideIndex >= 0) {
            const mobileOffset = -targetSlideIndex * 100;
            const mobileGapOffset = -targetSlideIndex * 0;
            currentTrackMobile.style.transform = `translateX(calc(${mobileOffset}% + ${mobileGapOffset}px))`;
          }
        }
      }
    }
    
    // 文本轨道 - 淡入淡出
    const contentSlides = Array.from(this.contentTrack.querySelectorAll('.mt-ptg__content-slide'));
    contentSlides.forEach((slide, idx) => {
      slide.classList.toggle('is-active', idx === this.blockIndex);
    });
  }

  showSlide() {
    // 找到当前应该显示的slide索引
    let targetIndex = 0;
    this.slides.forEach((s, idx) => {
      const bi = Number(s.getAttribute('data-block'));
      const ii = Number(s.getAttribute('data-img'));
      if (bi === this.blockIndex && ii === this.imageIndex) {
        targetIndex = idx;
      }
    });
    this.currentSlideIndex = targetIndex;
    this.updateTrackPosition();
    
    // 更新CTA
    const data = (this.blocksData.items || [])[this.blockIndex] || {};
    if (this.ctaEl) {
      this.ctaEl.textContent = data.cta_label || 'View details';
      this.ctaEl.setAttribute('href', data.cta_link || '#');
    }
    
    // 更新dots
    if (this.dotsBox) {
      Array.from(this.dotsBox.children).forEach((d, di) => {
        d.classList.toggle('is-active', di === this.blockIndex);
      });
    }
    
    // 移动端重新定位dots
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.relocateDotsForMobile();
    }
  }

  next() {
    const imgs = (this.blocksData.items[this.blockIndex]?.images || []).filter(i => i.exists);
    if (this.imageIndex < imgs.length - 1) {
      this.imageIndex++;
    } else {
      this.blockIndex = (this.blockIndex + 1) % (this.blocksData.items.length || 1);
      this.imageIndex = 0;
    }
    this.showSlide();
  }

  prev() {
    if (this.imageIndex > 0) {
      this.imageIndex--;
    } else {
      this.blockIndex = (this.blockIndex - 1 + (this.blocksData.items.length || 1)) % (this.blocksData.items.length || 1);
      const imgs = (this.blocksData.items[this.blockIndex]?.images || []).filter(i => i.exists);
      this.imageIndex = Math.max(0, imgs.length - 1);
    }
    this.showSlide();
  }

  handleDotClick(e) {
    const i = Array.from(this.dotsBox.children).indexOf(e.target);
    if (i >= 0) {
      this.blockIndex = i;
      this.imageIndex = 0;
      this.showSlide();
    }
  }
}

// 初始化函数
if (typeof initMtPicTextGroup === 'undefined') {
  window.initMtPicTextGroup = function(sectionId) {
    new MtPicTextGroup(sectionId);
  };
}
